import { onBeforeUnmount, ref } from 'vue'

export function useListenOnRoot(root, useLifecycle = true) {
  const registry = ref({}) // track all registered events and callbacks here.
  const eventRoot = root || document

  // Add a listener to the registry
  const registerRootListener = (event, callback) => {
    registry.value[event] = registry.value[event] || []
    if (!registry.value[event].includes(callback)) {
      registry.value[event].push(callback)
    }
  }

  // Remove a listener from the registry
  const unregisterRootListener = (event, callback) => {
    if (registry.value && registry.value[event]) {
      registry.value[event] = registry.value[event].filter(cb => cb !== callback)
    }
  }

  // Attach a listener to the root
  const listenOnRoot = (event, callback) => {
    if (eventRoot) {
      eventRoot.addEventListener(event, callback)
      registerRootListener(event, callback)
    }
  }

  // Remove a listener from the root
  const listenOffRoot = (event, callback) => {
    unregisterRootListener(event, callback)

    if (eventRoot) {
      eventRoot.removeEventListener(event, callback)
    }
  }

  // Dispatch an event on the root element
  const emitOnRoot = (event, detail) => {
    if (eventRoot) {
      eventRoot.dispatchEvent(new CustomEvent(event, { detail }))
    }
  }
  if (!useLifecycle) return { listenOnRoot, listenOffRoot, emitOnRoot }

  onBeforeUnmount(() => {
    // Unregister all registered listeners
    Object.keys(registry.value || {}).forEach(event => {
      registry.value[event].forEach(callback => {
        unregisterRootListener(event, callback)
      })
    })
    registry.value = null
  })

  return { listenOnRoot, listenOffRoot, emitOnRoot }
}
